// Front/src/utils/accuracyHelpers.js

export const rowDataDeviation = [
    {
      I: { min: 0, max: 50000 },
      II: { min: 0, max: 5000 },
      III: { min: 0, max: 500 },
      IV: { min: 0, max: 50 },
      multiplier: { Marketing: 0.5, Service: 1 },
      id: 3,
    },
    {
      I: { min: 50000.00001, max: 200000 },
      II: { min: 5000.00001, max: 20000 },
      III: { min: 500.00001, max: 2000 },
      IV: { min: 50.00001, max: 200 },
      multiplier: { Marketing: 1, Service: 2 },
      id: 4,
    },
    {
      I: { min: 200000.00001 },
      II: { min: 20000.00001, max: 100000 },
      III: { min: 2000.00001, max: 10000 },
      IV: { min: 200.00001, max: 1000 },
      multiplier: { Marketing: 1.5, Service: 3 },
      id: 5,
    },
    {
      I: { min: Number.NEGATIVE_INFINITY },
      II: { min: Number.NEGATIVE_INFINITY },
      III: { min: Number.NEGATIVE_INFINITY },
      IV: { min: Number.NEGATIVE_INFINITY },
      multiplier: { Marketing: 1.5, Service: 3 },
      id: 6,
    },
  ];
  
export const isWithinDeviation = ({ weight, actual, eValue, accuracyClass, reportType }) => {
    if (!eValue || !accuracyClass || !reportType) return false;

    const m = parseFloat(weight);
    const actualVal = parseFloat(actual);
    const e = parseFloat(eValue);

    if (isNaN(m) || isNaN(actualVal) || isNaN(e)) return false;

    // For Debugging
    // console.log("row.id:", row.id, "gotten for weight value: ", m);
    // console.log("row.multiplier[reportType]:", row.multiplier[reportType]);

    const newAllowedDeviation = getAllowedDeviation({
      weight: weight,
      e: eValue,
      accuracyClass: accuracyClass,
      scaleReportType: reportType
    });
  
    // For Debugging
    //console.log("new allowed deviation:", newAllowedDeviation);
    //console.log("old allowed deviation:", deviation);
    //console.log("Math.abs(actualVal) - Math.abs(m)", Math.abs(actualVal) - Math.abs(m));

    return Math.abs(Number((Math.abs(actualVal) - Math.abs(m)).toFixed(6))) <= newAllowedDeviation;
};


export const getAllowedDeviation = ({ weight, e, accuracyClass, scaleReportType }) => {
  const ratioedE = scaleReportType === 'Marketing' ? 0.5 * e : e;
  let classRatio = 1;

  // for debugging
  //console.log("accuracyClass =", accuracyClass);

  switch (accuracyClass) {
      case 1: // ONE
          classRatio = 1000;
          break;
      case 2: // TWO
          classRatio = 100;
          break;
      case 3: // THREE
          classRatio = 10;
          break;
      case 4: // FOUR
          classRatio = 1;
          break;
      default:
          classRatio = 1;
          break;  
  }

  // for debugging
  //console.log("classRatio = ", classRatio);

  const m = weight / e; // weight in e units

  if (0 * classRatio <= m && m <= 50 * classRatio) {
    return ratioedE * 1;
  } else if (50 * classRatio < m && m <= 200 * classRatio) {
      return ratioedE * 2;
  } else if (200 * classRatio < m && m <= 1000 * classRatio) {
      return ratioedE * 3;
  } else {
      return ratioedE * 3;
  }

};
